import React, { useRef } from 'react';
import { Avatar } from 'primereact/avatar';
import { Menu } from 'primereact/menu';
import { classNames } from 'primereact/utils';
import { useDispatch, useSelector } from 'react-redux';
import { MdLogout } from "react-icons/md";

import { logout } from '../../../store/slices/AuthSlice';
import { useTranslation } from 'react-i18next';
import SharedButton from '../../../components/Shared/SharedButton';
import ConfirmationModal from '../../../components/Shared/ConfirmationModal';
import { useNavigate } from 'react-router-dom';

const ProfileDropdown = () => {
  const profileMenu = useRef();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openLogoutModal, setOpenLogoutModal] = React.useState(false);
  const { user } = useSelector(state => state?.auth);
  const { t, i18n } = useTranslation();

  let profileItems = [
    {
      command: () => { },
      template: (item, options) => {
        return (
          <button
            onClick={e => options.onClick(e)}
            className={classNames(
              options.className,
              'w-full p-link flex items-center text-[16px] py-1.5 px-3 text-primary rounded-t-md'
            )}
          >
            <Avatar
              label={user?.full_name?.charAt(0)}
              className='h-[40px] text-[18px] text-black w-[40px] font-[500] mr-2'
              shape='circle'
            />
            <div className='flex flex-col align'>
              <span className='text-ellipsis w-32 capitalize font-semibold overflow-hidden whitespace-nowrap'>
                {user?.full_name}
              </span>
              <span className='text-14-gray'>
                {i18n?.language == 'ar' ? user?.role?.name_ar || 'Manager' : user?.role?.name_en || 'Manager'}
              </span>
            </div>
          </button>
        );
      }
    },
    {
      className: '!bg-gray-100',
      label: t('Logout'),
      icon: 'pi pi-sign-out',
      command: () => setOpenLogoutModal(true)
    }
  ];

  const handleLogout = () => {
    dispatch(logout());
    sessionStorage.clear();
    localStorage.clear();
    navigate('/login');
  };

  return (
    <div>
      <div onClick={e => profileMenu?.current?.toggle(e)} className='flex cursor-pointer gap-3 items-center'>
        <SharedButton
          buttonType='reset'
          icon='pi pi-angle-down'
          label={user?.full_name}
          onClick={e => profileMenu?.current?.toggle(e)}
          className='!border-0 whitespace-nowrap !h-[28px]'
        />
      </div>
      <Menu
        model={profileItems}
        popup
        ref={profileMenu}
        id='popup_profile_menu'
        className='border-none shadow-lg text-14-gray !bg-gray-100 custom-menu mt-4 px-0 py-0'
        pt={{
          root: { className: '!rounded-md' },
          menuitem: { className: 'border-b border-gray-200 py-2' },
          label: { className: '!text-14-dark group-hover:text-primary' },
          action: { className: 'py-3 px-3 bg-gray-100' },
          content: { className: 'bg-transparent group !hover:rounded-md' },
          icon: { className: 'text-14-dark group-hover:text-primary' }
        }}
        style={{ width: '20rem' }}
      />
      <ConfirmationModal
        message='Are you sure you want to log out?'
        Icon={MdLogout}
        visible={openLogoutModal}
        setVisible={setOpenLogoutModal}
        acceptLabel={'Logout'}
        rejectLabel={'Cancel'}
        onAccept={handleLogout}
      />
    </div>
  );
};

export default ProfileDropdown;
